import React, { ReactNode } from 'react';
import { useFormik } from 'formik';
import _ from 'lodash';

import {
  Row,
  Col,
  Button,
  Modal,
  Offcanvas,
  Tabs,
  Tab,
} from 'react-bootstrap';
// import styled from 'styled-components';
// import { up, down } from 'styled-breakpoints';

import { Spin, Radio } from 'antd';

// Redux
import { useDispatch } from 'react-redux';
import { RootState, AppDispatch, useTypedSelector } from '../../../../../v5/utils/store.tsx';
import slice, { fields, FormikContext, initialValues, formSchema, prepareForm, prepareData, prepareTab2, prepareTab2OnCreate } from './slice.tsx';
import sliceJob from '../../slice.tsx';
// import confirmSlice from '../../../../components/modal/confirmSlice.tsx';

// enums
import { warning, isNumeric } from '../../../../../v5/utils/utils.tsx';
// import {  } from '../../../../../v5/utils/enums.tsx';

import Tab1 from './Tab1.tsx';
import Tab2 from './Tab2.tsx';

// import { ReactComponent as TrashIcon } from "../../../../../v5/assets/icons/trash-2.svg";

// ----------------------------------------------------------------------


const FormElement = ({ onSave }: any) => {
  const { isLoading, show, groupIndex, blockIndex, stepIndex, step, eventKey } = useTypedSelector((state: RootState) => state.jobFormDefaultLocationFormSlice);
  const { defaultLocations } = useTypedSelector((state: RootState) => state.jobFormSlice);
  const dispatch = useDispatch<AppDispatch>();
  
  const formikRef = React.useRef<any>(null);


  React.useEffect(() => {
    if(show){
      dispatch(slice.setLoading(true));
      dispatch(slice.setEventKey((step?.hasDefaultSite) ? 'tab1' : 'tab2'));
      let form = prepareForm(step, initialValues);
      setValues(form);
      dispatch(slice.setLoading(false));
    }
  }, [show]);

  
  React.useEffect(() => {
    if(show){
      let data: any = null;
      if(step?.hasDefaultSite || isNumeric(step?.defaultLocationId)){
        if(eventKey === 'tab1'){
          data = step;
        } else {
          data = null;
        }
      } else {
        if(eventKey === 'tab1'){
          data = null;
        } else {
          data = step;
        }
      }

      dispatch(slice.setLoading(true));
      let form = prepareForm(data, initialValues);
      setValues(form);
      setTimeout(() => {
        setErrors({});
      }, 0);
      dispatch(slice.setLoading(false));
    }
  }, [eventKey]);
  

  const formik = useFormik({
    initialValues: initialValues,
    validateOnMount: false,
    validateOnChange: true,
    validationSchema: formSchema(eventKey),
    onSubmit: values => {
      onSubmit(values)
    },
  });
  const { values, errors, setValues, setErrors, setFieldValue, validateForm, handleSubmit }: any = formik;
  formikRef.current = formik;


  const onSubmit = (values: any) => {
    if(eventKey === 'tab1'){
      if(onSave){
        onSave(groupIndex, blockIndex, stepIndex, step, values, true)
        onCancel();
      }

    } else {
      if(values?.isSaveDefaultLocation){
        let params = prepareData(values);
        dispatch(slice.callCreateApi(params, (state: boolean, data: any) => {
          if(state){
            let defaultLocationsArr = _.cloneDeep(defaultLocations);
            let index = defaultLocationsArr.findIndex((x: any) => x.defaultLocationId == data?.defaultLocationId);
            if (index === -1) {
              defaultLocationsArr.push(data);
              dispatch(sliceJob.setDefaultLocations(defaultLocationsArr));
            }

            if(onSave){
              let form = prepareTab2OnCreate(data, initialValues, values?.isSaveDefaultLocation);
              onSave(groupIndex, blockIndex, stepIndex, step, form, true)
              onCancel();
            }
          }
        }));

      } else {
        if(onSave){
          let form = prepareTab2(values);
          onSave(groupIndex, blockIndex, stepIndex, step, form, false)
          onCancel();
        }
      }
    }
  }
  const onCancel = () => {
    let form = prepareForm(null, initialValues);
    setValues(form);
    dispatch(slice.setShow({ show: false, group: null, groupIndex: null, block: null, blockIndex: null, step: null, stepIndex: null }));
    dispatch(slice.setEventKey('tab1'));
    dispatch(slice.resetSlice());
  }


  const setFooter = () => {
    return <Row className='gx-12 w-100'>
      <Col xs={true}></Col>
      <Col xs={'auto'}>
        <Button
          variant={'custom-text'}
          size={'sm'}
          disabled={isLoading}
          onClick={() => {
            onCancel();
          }}
        >Cancel</Button>
      </Col>
      <Col xs={'auto'}>
        <Button
          variant={'custom-primary'}
          size={'sm'}
          disabled={isLoading}
          onClick={() => {
            handleSubmit();
          }}
        >Save</Button>
      </Col>
    </Row>
  }


  return <Offcanvas
    backdrop={'static'}
    enforceFocus={false}
    scroll={false}
    placement={'end'}
    show={show}
    onHide={() => {
      onCancel();
    }}
    style={{ width: '700px' }}
  >
    <FormikContext.Provider value={formik}>
      <Offcanvas.Header closeButton>
          <Offcanvas.Title>Edit Default Location</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className='pt-12'>
        <Spin spinning={isLoading} wrapperClassName={'no-height'}>
          <Tabs
            fill
            activeKey={eventKey}
            onSelect={(ek: any) => {
              dispatch(slice.setEventKey(ek));
            }}
          >
            <Tab eventKey={'tab1'} title={<><Radio checked={(eventKey === 'tab1')} /><span>Default Location</span></>} disabled={false}>{(eventKey === 'tab1') && <Tab1 />}</Tab>
            <Tab eventKey={'tab2'} title={<><Radio checked={(eventKey === 'tab2')} /><span>Custom Location</span></>} disabled={false}>{(eventKey === 'tab2') && <Tab2 />}</Tab>
          </Tabs>
        </Spin>
      </Offcanvas.Body>
      <Modal.Footer>{setFooter()}</Modal.Footer>
    </FormikContext.Provider>
  </Offcanvas>
}

export default FormElement;
